import { render } from "./atmosReceipt.vue?vue&type=template&id=8294c83a&scoped=true"
import script from "./atmosReceipt.vue?vue&type=script&lang=js"
export * from "./atmosReceipt.vue?vue&type=script&lang=js"

import "./atmosReceipt.vue?vue&type=style&index=0&id=8294c83a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8294c83a"]])

export default __exports__